import { Skeleton } from '@common/components';
import { cn } from '@core/utils';

const DesktopSkeletonListItem = () => {
  return (
    <li className={cn('flex grow items-center gap-16')}>
      <Skeleton className="size-104 rounded-xlarge" />
      <div className="flex grow flex-col gap-8">
        <Skeleton className="h-27 w-full rounded-xxsmall" />
        <Skeleton className="h-27 w-2/3 rounded-xxsmall" />
        <Skeleton className="h-27 w-1/2 rounded-xxsmall" />
      </div>
    </li>
  );
};

export const DesktopSkeletonCover = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'z-10 flex size-full flex-col bg-[#767676] pb-[calc(20px+var(--safe-area-bottom,0px))] pt-20',
        className,
      )}
    >
      <div className="mb-34 flex items-center justify-between px-40 content-container">
        <Skeleton className="h-36 w-106 rounded-xxsmall" />
        <Skeleton className="h-44 w-[352px] rounded-xxsmall" />
        <Skeleton className="h-24 w-222 rounded-xxsmall" />
      </div>
      <div className="mb-80 flex h-240 shrink-0 justify-center gap-12 overflow-hidden">
        <Skeleton className="h-full w-[670px] shrink-0 rounded-large" />
        <Skeleton className="h-full w-[670px] shrink-0 rounded-large" />
        <Skeleton className="h-full w-[670px] shrink-0 rounded-large" />
      </div>
      <Skeleton className="mx-auto mb-16 h-36 w-230 shrink-0 rounded-xxsmall" />
      <ul className="mb-160 flex gap-40 px-40 py-28 content-container">
        <DesktopSkeletonListItem />
        <DesktopSkeletonListItem />
        <DesktopSkeletonListItem />
      </ul>

      <Skeleton className="mx-auto mb-16 h-34 w-204 shrink-0 rounded-xxsmall" />
      <ul className="flex h-[340px] shrink-0 gap-20 px-40 content-container">
        <Skeleton className="h-full w-224 shrink-0 rounded-xlarge" />
        <Skeleton className="h-full w-224 shrink-0 rounded-xlarge" />
        <Skeleton className="h-full w-224 shrink-0 rounded-xlarge" />
        <Skeleton className="h-full w-224 shrink-0 rounded-xlarge" />
        <Skeleton className="h-full w-224 shrink-0 rounded-xlarge" />
      </ul>
    </div>
  );
};
